/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;

    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const menu = navigation.querySelector('.gh-navigation-menu');
    const openMenu = function () {
        navigation.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflowY = 'hidden';
        menu?.querySelector('a')?.focus();
    };
    const closeMenu = function (restoreFocus = true) {
        navigation.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflowY = '';
        if (restoreFocus) burger.focus();
    };

    burger.addEventListener('click', function () {
        navigation.classList.contains('is-open') ? closeMenu(false) : openMenu();
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && navigation.classList.contains('is-open')) {
            closeMenu();
        }

        if (event.key === 'Tab' && navigation.classList.contains('is-open')) {
            const focusable = Array.from(navigation.querySelectorAll('a[href], button:not([disabled])'))
                .filter(function (element) {
                    return element.offsetParent !== null;
                });
            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last?.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first?.focus();
            }
        }
    });

    window.addEventListener('resize', function () {
        if (window.innerWidth > 767 && navigation.classList.contains('is-open')) {
            closeMenu(false);
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
